<div>
  <h1 mat-dialog-title>Contact Us</h1>
  <div mat-dialog-content>
    <a href="tel:+2347004347746">
        <span><b>0700 434 7746</b></span>
    </a>
    <a href="mailto:akinmorin.bolaji@heirsgeneralinsurance.com" target="_blank">
      <div><b> wecare&#64;heirsgeneralinsurance.com</b></div>
    </a>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>


